module.exports = __webpack_public_path__ + "img/public/AdminIcons/whistListDeleteIcon.svg?c97c696d";